import { convertMediaUrl } from "@montana/helpers/media-src.helper";
import { IColorMaterialDescriptionBlock } from "@montana/models/generated/cms.interface";
import { MaterialSwatch } from "@montana/shared/material-swatch/material-swatch.component";
import React from "react";

export const ColorMaterialDescriptionBlock: React.VFC<IColorMaterialDescriptionBlock> = props => {
    return (
        <article className="color-material-description-block">
            {props.header && (
                <h1 className="color-material-description-block__heading">
                    {props.header}
                </h1>
            )}

            {props.headerDescription && (
                <p className="color-material-description-block__description">
                    {props.headerDescription}
                </p>
            )}

            <ul className="color-material-description-block__materials">
                {props.colorMaterials &&
                    props.colorMaterials.map((material, index) => (
                        <li
                            className="color-material-description-block__material"
                            key={index}
                        >
                            <MaterialSwatch
                                className="color-material-description-block__material-image"
                                imageSrc={convertMediaUrl(
                                    material.colorSwatchImage?.url
                                )}
                                color={material.hexCode}
                            />

                            {material.colorDescription && (
                                <div className="color-material-description-block__material-name">
                                    {material.colorDescription}
                                </div>
                            )}

                            {material.surface && (
                                <div className="color-material-description-block__material-description">
                                    {material.surface}
                                </div>
                            )}
                        </li>
                    ))}
            </ul>
        </article>
    );
};
